import React, { lazy } from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { DarkChatBubble } from '../shared/DarkChatBubble';
import { Sign } from '../../data/signs';
interface SignReviewsProps {
  sign: Sign;
}
export function SignReviews({
  sign
}: SignReviewsProps) {
  const getReviews = (signId: string) => {
    switch (signId) {
      case 'escorpio':
        return [{
          text: 'El Núcleo Escorpio fue como leer mi alma. Nunca había entendido por qué mi intensidad me asusta tanto como me define.',
          author: 'L.M. — Escorpio'
        }, {
          text: 'Compré el Archivo Sombrío y lloré. Finalmente alguien puso en palabras lo que siempre he sentido pero nunca he podido explicar.',
          author: 'R.V. — Escorpio'
        }, {
          text: 'La Cámara Astral de Escorpio es perturbadora y hermosa. Es exactamente la atmósfera que vive dentro de mí.',
          author: 'D.S. — Escorpio'
        }];
      case 'leo':
        return [{
          text: 'El Núcleo Leo me mostró que mi necesidad de brillar no es vanidad. Es mi forma de existir. Eso cambió todo.',
          author: 'A.R. — Leo'
        }, {
          text: 'Nunca había entendido por qué mi generosidad a veces me deja vacío. El Archivo Sombrío lo explicó perfectamente.',
          author: 'M.T. — Leo'
        }, {
          text: 'Compré el reino completo y cada archivo fue una revelación. Leo no es solo orgullo. Es fuego que necesita expresarse.',
          author: 'J.L. — Leo'
        }];
      case 'aries':
        return [{
          text: 'El Núcleo Aries me hizo entender por qué siempre empiezo cosas y no las termino. No es falta de compromiso. Es mi naturaleza.',
          author: 'C.P. — Aries'
        }, {
          text: 'El Ritual del Eclipse de Aries fue exactamente lo que necesitaba. Ahora canalizo mi fuego sin quemarme.',
          author: 'N.G. — Aries'
        }, {
          text: 'Compré el Códice de Compatibilidad y finalmente entendí por qué choco tanto con ciertos signos. Es revelador.',
          author: 'F.M. — Aries'
        }];
      default:
        return [{
          text: `El Núcleo ${sign.name} fue exactamente lo que necesitaba. Finalmente entiendo mi energía.`,
          author: `M.R. — ${sign.name}`
        }, {
          text: `Compré el reino completo y cada archivo fue una revelación sobre mi arquetipo.`,
          author: `A.V. — ${sign.name}`
        }];
    }
  };
  const reviews = getReviews(sign.id);
  const REVIEWS_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/YP30k_u7fBp15AsfUvFQEXkcYSPiRak1qVO1lsfmZBzfMTpFtgG7EusPp9oru_abc94YZ6lBWI5wxOR0KSyLZokFbYHBWzEjruQyf9We7WavEfEed3FPuq4rD_4WmprI.jpg?v=1778629864';
  return <section className="relative py-20 px-6 overflow-hidden" data-id="element-449">
      {/* Background image tinted with sign color, lighter overlay */}
      <div className="absolute inset-0 z-0" data-id="element-450">
        <img src={REVIEWS_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-451" />
        <div className="absolute inset-0 bg-cosmic-black/60" data-id="element-452" />
        <div className="absolute inset-0" style={{
        backgroundColor: sign.colors.primary,
        opacity: 0.2
      }} data-id="element-453" />
        <div className="absolute inset-0" style={{
        background: `linear-gradient(180deg, #050508 0%, ${sign.colors.primary}10 50%, #050508 100%)`
      }} data-id="element-454" />
      </div>
      <div className="relative z-10 container mx-auto max-w-4xl" data-id="element-455">
        <AnimatedSection data-id="element-456">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-4" data-id="element-457">
            Experiencias {sign.name}
          </h2>
          <p className="text-center mb-16" style={{
          color: sign.colors.accent
        }} data-id="element-458">
            Lo que otros {sign.name} descubrieron
          </p>
        </AnimatedSection>

        <div className="space-y-6" data-id="element-459">
          {reviews.map((review, index) => <DarkChatBubble key={index} text={review.text} author={review.author} delay={index * 0.15} side={index % 2 === 0 ? 'left' : 'right'} data-id="element-460" />)}
        </div>
      </div>
    </section>;
}